import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var ClapSVG = function ClapSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M9.468,10.21h0a2.345,2.345,0,0,1,2.345,2.345v4.814a.586.586,0,0,0,1,.415l2.458-2.458,9.859-9.859a2.433,2.433,0,0,1,3.1-.345,2.346,2.346,0,0,1,.3,3.572l-6.218,6.218a.586.586,0,0,0,.829.829l7.787-7.787a2.433,2.433,0,0,1,3.1-.345,2.346,2.346,0,0,1,.3,3.572l-7.876,7.876a.586.586,0,0,0,.829.829l6.129-6.129a2.433,2.433,0,0,1,3.1-.345,2.346,2.346,0,0,1,.3,3.572L30.608,23.2a.586.586,0,1,0,.829.829l4.471-4.471a2.432,2.432,0,0,1,3.1-.344,2.345,2.345,0,0,1,.3,3.571l-8.29,8.291-4.145,4.145a9.379,9.379,0,0,1-13.264,0l-1.8-1.8-1.255-1.255a11.724,11.724,0,0,1-3.434-8.29h0V12.555h0A2.344,2.344,0,0,1,9.468,10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M29.062,13.442a1.7,1.7,0,0,1,0,2.4l-9.216,9.216a1.133,1.133,0,1,0,1.6,1.6l7.613-7.613a1.7,1.7,0,1,1,2.4,2.4l-7.613,7.613a1.133,1.133,0,1,0,1.6,1.6l4.408-4.408a1.7,1.7,0,1,1,2.4,2.405l-8.415,8.414a9.066,9.066,0,0,1-12.822,0L9.445,35.5a11.33,11.33,0,0,1-3.319-8.014V17.048a1.7,1.7,0,0,1,1.7-1.7h0a1.7,1.7,0,0,1,1.7,1.7v2.777a1.11,1.11,0,0,0,.325.8,1.132,1.132,0,0,0,1.61,0l9.588-9.588a1.7,1.7,0,0,1,2.405,2.4l-7.614,7.613a1.133,1.133,0,1,0,1.6,1.6l9.216-9.216a1.7,1.7,0,0,1,2.4,0m1.6-1.6a3.973,3.973,0,0,0-4.612-.726,3.966,3.966,0,0,0-6.607-1.678l-7.654,7.654v-.041a3.967,3.967,0,1,0-7.933,0V27.483A13.51,13.51,0,0,0,7.842,37.1l1.586,1.586a11.346,11.346,0,0,0,16.028,0l8.415-8.415A3.967,3.967,0,0,0,32.4,23.73l.671-.671a3.967,3.967,0,0,0-1.677-6.608,3.975,3.975,0,0,0-.727-4.612Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M16,1a1,1,0,0,1,1,1V5a1,1,0,0,1-2,0V2A1,1,0,0,1,16,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M23,4a1,1,0,0,1-.293.707l-2,2a1,1,0,0,1-1.414-1.414l2-2A1,1,0,0,1,23,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M10,3a1,1,0,0,1,.707.293l2,2a1,1,0,0,1-1.414,1.414l-2-2A1,1,0,0,1,10,3Z"
  }));
};
ClapSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
ClapSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Clap")
};
export default withDetailedIcon(ClapSVG);